import { render, staticRenderFns } from "./CompareTabs.vue?vue&type=template&id=ce4fc70e"
import script from "./CompareTabs.vue?vue&type=script&lang=js"
export * from "./CompareTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports